import React from "react";
import {
  AugmentedPersonMap,
  InviteAttendeesInput,
} from "../onboarding-org-invite/OnboardingOrgInvite";
import { OrgInviteCheckbox } from "../org-invite-checkbox";

export const OnboardingOrgBulkInvite = ({
  eventsMap,
  eventsSelectedForInvite,
  onAddInvitees,
}: {
  eventsMap: {
    [keyof: string]: AugmentedPersonMap;
  };
  eventsSelectedForInvite: string[];
  onAddInvitees: (eventGroupName: string, attendeesInviteInput: InviteAttendeesInput[]) => void;
}) => {
  return (
    <div>
      {Object.keys(eventsMap).map((event) => {
        const attendeesList = Object.values(eventsMap[event]);
        return (
          <OrgInviteCheckbox
            key={event}
            people={attendeesList}
            eventName={event}
            isChecked={eventsSelectedForInvite.indexOf(event) > -1}
            onCheck={(invitees) => {
              onAddInvitees(event, invitees);
            }}
          />
        );
      })}
    </div>
  );
};
